import React, { FC, useRef } from 'react';
import type { PayallStoryTheSolutionProps } from '@/types';
import { ContentManager } from '../content-manager';
import { Image } from '../image';
import { useInView } from '@/hooks/reveal-in-view';

export const PayallStoryTheSolution: FC<PayallStoryTheSolutionProps> = ({
  title,
  description,
  image,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section className="payallStoryTheSolution">
      <div className="payallStoryTheSolution--inner">
        <div className="payallStoryTheSolution--content" ref={ref}>
          {image?.file?.url && (
            <Image
              className="payallStoryTheSolution--image"
              src={image as any}
              animateInView
              alt={image.title}
              style={{
                transform: isInView ? 'none' : `translateY(20px)`,
                opacity: isInView ? 1 : 0,
                transition: 'all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)',
              }}
              options={{
                sizes: {
                  exec: [
                    {
                      width: 704,
                      height: 663,
                    },
                  ],
                },
              }}
            />
          )}
          <div className="payallStoryTheSolution--text">
            {title && (
              <ContentManager
                content={title}
                className="payallStoryTheSolution--title"
                style={{
                  transform: isInView ? 'none' : `translateY(20px)`,
                  opacity: isInView ? 1 : 0,
                  transition: 'all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)',
                }}
              />
            )}
            {description && (
              <ContentManager
                content={description}
                className="payallStoryTheSolution--description"
                style={{
                  transform: isInView ? 'none' : `translateY(20px)`,
                  opacity: isInView ? 1 : 0,
                  transition: 'all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)',
                }}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
